import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyChQoGZ_MEhZQOFWxmo2nlgJK3to4A9Q3Y',
  authDomain: 'learnwithinfobloom.firebaseapp.com',
  projectId: 'learnwithinfobloom',
  storageBucket: 'learnwithinfobloom.firebasestorage.app',
  messagingSenderId: '41005566298',
  appId: '1:41005566298:web:c2c513cec55f504e21cb63',
  measurementId: 'G-BYJJN7BCR2',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
